<template>
    <div class="features" v-if="active">

        <div class="timeslot text-right">

            <base-button type="primary" outline
                class="btn-icon-only rounded-circle mr-1"
                @click="createOrUpdateNote"
                v-if="!timeslot.is_instruction && (features.canEdit() || hasTimeslotComment(timeslot.id))"
            >
                <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                <span class="badge badge-md badge-circle badge-floating badge-warning no-border"
                        v-if="hasTimeslotComment(timeslot.id)">
                    {{ stats.timeslots[timeslot.id].notes }}
                </span>
            </base-button>

            <base-button type="primary" outline
                class="btn-icon-only rounded-circle mr-1"
                @click="createOrUpdatePicture"
                v-if="!timeslot.is_instruction && (features.canEdit() || hasTimeslotPicture(timeslot.id))"
            >
                <span class="btn-inner--icon"><i class="fas fa-paint-brush"></i></span>
                <span class="badge badge-md badge-circle badge-floating badge-warning no-border"
                        v-if="hasTimeslotPicture(timeslot.id)">
                    {{ stats.timeslots[timeslot.id].pictures }}
                </span>
            </base-button>

            <base-button type="primary" outline
                class="btn-icon-only rounded-circle mr-3"
                @click="createIssue"
            >
                <span class="btn-inner--icon"><i class="fas fa-exclamation"></i></span>
                <span class="badge badge-md badge-circle badge-floating badge-warning no-border"
                        v-if="stats && stats.timeslots[timeslot.id] && stats.timeslots[timeslot.id].issues">
                    {{ stats.timeslots[timeslot.id].issues }}
                </span>
            </base-button>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            registration: {
                type: Object,
                required: true
            },

            degree: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            stats: {
                type: Object,
                default: null
            },

            timeslot: {
                type: Object,
                required: true
            },

            features: {
                type: Object,
            },
        },

        data() {
            const context = this.session ? 'session' : 'log'
            return {
                feedbackEndpoint: '/socrates/api/front/dashboard/data/context/' + context + '/feedbacks',
            }
        },

        computed: {

            active() {
                return true
            },

            marked() {
                return this.stats !== null && this.stats.timeslots[this.timeslot.id] !== undefined && this.stats.timeslots[this.timeslot.id].mark > 0
            },
        },

        methods: {
            
            hasTimeslotComment(timeslotId) {
                return this.stats && this.stats.timeslots[timeslotId] && this.stats.timeslots[timeslotId].notes
            },

            hasTimeslotPicture(timeslotId) {
                return this.stats && this.stats.timeslots[timeslotId] && this.stats.timeslots[timeslotId].pictures
            },

            refresh() {
                this.$emit('refresh')
            },

            markTimeslot(value) {
                // A timeslot may be missing in the stats.
                if (!this.stats.timeslots[this.timeslot.id]) {
                    this.stats.timeslots[this.timeslot.id] = { pictures: 0, notes: 0, issues: 0, mark: 0}
                }
                if (value) {
                    axios.post(this.feedbackEndpoint, {
                        type: 'mark',
                        registration_id: this.registration.id,
                        simulation_id: this.simulation.id,
                        session_id: this.session ? this.session.id : null,
                        timeslot_id: this.timeslot.id,
                    })
                    .then(resp => {
                        this.refresh()
                    })
                    .catch(err => {
                        this.$auth.handleErrorVm(err, this)
                    })        

                    // The mark prop takes the mark ID. Assign a temporary one.
                    this.stats.timeslots[this.timeslot.id].mark = 999999999
                } else {
                    const markId = this.stats.timeslots[this.timeslot.id].mark
                    axios.delete(this.feedbackEndpoint + '/' + markId)
                    .then(resp => {
                        this.refresh()
                    })
                    .catch(err => {
                        if (err.response.status == 404) {
                            // This may happen with very closed interactions, do nothing
                            return
                        }
                        this.$auth.handleErrorVm(err, this)
                    })        
                    // The mark prop takes the mark ID. Remove it.
                    this.stats.timeslots[this.timeslot.id].mark = 0
                }
            },

            createOrUpdateNote() {
                this.$emit('createOrUpdateNote', this.timeslot)
            },

            createOrUpdatePicture() {
                this.$emit('createOrUpdatePicture', this.timeslot)
            },

            createIssue() {
                this.$emit('createIssue', this.timeslot)
            },
        }
    }
</script>

<style scoped>

    .features .timeslot >>> button {
        z-index: 1000;
        background-color: white;
        border-color: white;
        color: #212529;
    }
    .features .timeslot >>> button:hover {
        box-shadow: none;
    }
    .features .timeslot >>> button:active {
        background-color: #d2e3ee;
        border-color: white;
        color: #212529;
    }
    .features .timeslot >>> button .badge {
        border: none;
        width: 1.4rem;
        height: 1.4rem;
    }
    .no-border {
        border-width: 0
    }

</style>
